import React, { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DropdownMultiselect from "react-multiselect-dropdown-bootstrap";
import MultiSelect from "react-multi-select-component";
import moment from "moment";
import jsPDF from "jspdf";
import * as htmlToImage from "html-to-image";
import { BsTable } from "react-icons/bs";
import html2pdf from "html2pdf.js";
import { getAmc } from "../../stores/services/amc.service";
import { getFundByAmc } from "../../stores/services/funds.service";
import {
  getBankStatement,
  getBankStatementByLedgerId,
  getBankStatementOpeningBalance,
} from "../../stores/services/report.service";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import ReportHeader from "./report-header";
import { useSelector } from "react-redux";
import {
  numberWithCommas,
  getLedgerAccounts,
  validDate,
  isNumber,
  exportToTxt,
  generateExcel,
} from "../../utils/customFunction";
import Select from "react-select";
import { getNewChartsOfAccountsByFund } from "../../stores/services/chatofaccounts.service";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";

const BankStatement = () => {
  const contentRef = React.useRef(null);
  const ColumnHeading = [
    { label: "Create Date", value: "Create Date" },
    { label: "Settlement Date", value: "Settlement Date" },
    { label: "Transaction ID", value: "Transaction ID" },
    { label: "Description", value: "Description" },
    { label: "Debit Amount", value: "Debit Amount" },
    { label: "Credit Amount", value: "Credit Amount" },
    { label: "Balance", value: "Balance" },
  ];
  const [ColumnArr, setColumnArr] = useState(ColumnHeading);
  const [selectedValues, setSelectedValues] = useState<any>({
    heading: "",
    sub_heading: "",
    columns: ColumnHeading?.map?.((col) => col?.value),
    balance: ["Opening Balance", "Closing Balance"],
  });
  const [fontSizeVal, setFontSizeVal] = useState<any>(18);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [loadingText, setLoadingText] = useState(false);
  const [paperSizeVal, setPaperSizeVal] = useState("A4");
  const [layoutVal, setLayoutVal] = useState("Landscape");
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState();
  const [dimensionOfPages, setDimensionOfPages] = useState<any>();
  const [itemsPerPage, setItemsPerPage] = useState<any>(10);
  const [itemsToShow, setItemsToShow] = useState(10);
  // const contentStyle = {
  //   width: `${Number(
  //     dimensionOfPages?.find((item) => item?.key == paperSizeVal)?.dimensions[layoutVal == "Portrait" ? 0 : 1]
  //   ) * (Number(screenSizePerPdf))}px`,
  //   height: 'auto',
  //   margin: '0 auto',
  // };

  const [screen, setScreen] = useState<any>();
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const pdfExportComponent = React.useRef<PDFExport>(null);
  const [loading, setLoading] = useState(false);
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";
  let date = new Date();
  const [bankStatement, setBankStatement] = useState<any>([]);
  const [bankStatementDataCount, SetBankStatementDataCount] = useState(0);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [allFundAccounts, setAllFundsAccounts] = useState<any>([]);
  const [fund, setFund] = useState("");
  const [fundCode, setFundCode] = useState("");
  // const [type, setType] = useState("");
  const [fundAccount, setFundAccount] = useState("");
  const [accountTitle, setAccountTitle] = useState("");
  const [openingBalance, setOpeningBalance] = useState<any>("");
  const [closingBalance, setClosingBalance] = useState<any>("");
  const [fromDate, setFromDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [isSearchTrue, setIsSearchTrue] = useState(false);

  // const [resAmc, setResAmc] = useState("");
  const [resFund, setResFund] = useState("");
  // const [resType, setResType] = useState("");
  const [resFundAccount, setResFundAccount] = useState("");
  const [resAccountTitle, setResAccountTitle] = useState("");
  // const [resAccountNo, setResAccountNo] = useState("");
  const [resFromDate, setResFromDate] = useState(
    moment(date).format("YYYY-MM-DD")
  );
  const [resToDate, setResToDate] = useState(moment(date).format("YYYY-MM-DD"));

  // const chartOfAccounts = useSelector((state: any) => state.chartofAccounts);
  const [chartOfAccounts, setChartOfAccounts] = useState<any>(undefined);

  const [hasActivity, setHasActivity] = useState(false);
  const [accountGlCode, setAccountGlCode] = useState("");

  const getAllAmcFunds = async () => {
    try {
      // allFundAccounts.length=0;
      // setAllFundsAccounts(allFundAccounts);
      allFunds.length = 0;
      setAllFunds(allFunds);
      const response = await getFundByAmc(
        email,
        amc_code,
        fund_code?.length > 0 ? fund_code : ""
      );
      setAllFunds(response.data.data);
    } catch (error) {}
  };

  React.useEffect(() => {
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // useEffect(() => {

  //   getAllAmcFunds();
  // }, []);

  React.useEffect(() => {
    getAllAmcFunds();
  }, [fund_code]);

  const getChartOfAccountsFromBackend = async () => {
    try {
      setLoading(true);
      let response = await getNewChartsOfAccountsByFund(
        email,
        amc_code,
        fund?.split("-")[fund?.split("-").length - 1].trim()
      );
      if (response.data.status === 200) {
        setChartOfAccounts(response.data.data?.main_family);
        setLoading(false);
      } else {
        toast.error("No associated chart of account!");

        setChartOfAccounts(undefined);
      }
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message?.toString());
      } else {
        toast.error(err.message || "Request Failed!");
      }
    }
  };

  React.useEffect(() => {
    if (fund) {
      getChartOfAccountsFromBackend();
    }
  }, [fund]);

  const getLedgerAccountsByChart = async () => {
    try {
      let ledgersacc = await getLedgerAccounts(
        chartOfAccounts[0].family[3].sub_family
      );

      setAllFundsAccounts(ledgersacc);
    } catch (error) {}
  };

  React.useEffect(() => {
    if (chartOfAccounts && chartOfAccounts.length > 0) {
      getLedgerAccountsByChart();
    }
  }, [chartOfAccounts]);

  // let txnTypes = JSON.parse(sessionStorage.getItem('txnType') || '');

  // const CapTxnType = (type: any) => {
  //     let i, txType;
  //     for (i = 0; i < txnTypes.length; i++) {
  //     if (txnTypes[i].api_name === type) {
  //         txType = txnTypes[i].dis_name;
  //         break;
  //     }
  //     }
  //     return txType;
  // };

  // const renderFundsDropDown = () => {
  //   return allFunds.map((item: any, index: number) => {
  //     return (
  //       <option key={index} value={item.symbol_code}>
  //         {item.fund_name} - {item.symbol_code}
  //       </option>
  //     );
  //   });
  // };

  const renderFundsDropDown = () => {
    return allFunds.map((item: any, index: number) => {
      return {
        value: item.symbol_code,
        label: `${item.fund_name} - ${item.symbol_code}`,
      };
    });
  };

  // const renderFundAccountsDropDown = () => {
  //   return allFundAccounts.map((item: any, index: number) => {
  //     return (
  //       <option key={index} value={item.code}>
  //         {item.account_title}
  //       </option>
  //     );
  //   });
  // };

  const renderFundAccountsDropDown = () => {
    return allFundAccounts.map((item: any, index: number) => {
      return {
        value: item.code,
        label: item.account_title,
      };
    });
  };

  //code for search data for Reports

  const searchData = async () => {
    setIsSearchTrue(false);
    setItemsPerPage(10);
    setBankStatement([]);
    try {
      // bankStatement.length = 0;
      // setBankStatement(bankStatement);
      setLoading(true);
      setBankStatement([]);
      setOpeningBalance("0");
      setClosingBalance("0");
      // let fromMonths = new Date(fromDate);
      // let toMonths = new Date(toDate);
      // var premonths;
      // premonths = (toMonths.getFullYear() - fromMonths.getFullYear()) * 12;
      // premonths -= fromMonths.getMonth();
      // premonths += toMonths.getMonth();
      // if(premonths<6){
      // const response = await getBankStatement(email, fundAccount, fromDate,toDate,type);
      const response = await getBankStatementByLedgerId(
        email,
        // fundAccount,
        accountGlCode,
        fromDate,
        toDate,
        "Realized",
        fundCode
      );
      // const openingResponse = await getBankStatementOpeningBalance(
      //   email,
      //   fundAccount,
      //   fromDate
      // );
      // let sortedData = response?.data?.data.sort(
      //   (a, b) => b.created_at_time - a.created_at_time
      // );

      if (response.status === 200 && response.data.status === 200) {
        // let sortedData = response?.data?.data.sort(
        //   (a, b) => b.created_at_time - a.created_at_time
        // );

        let sortedData = response?.data?.data.sort(
          (a, b) => a.created_at_time - b.created_at_time
        );

        if (sortedData && sortedData.length > 0) {
          let opening = sortedData[0].previous_balance;

          setOpeningBalance(sortedData[0].previous_balance);

          // setClosingBalance(sortedData[sortedData.length - 1].balance);

          sortedData = sortedData.map((item) => {
            opening =
              opening +
              parseFloat(item.debit_amount || "0") -
              parseFloat(item.credit_amount || "0");
            return {
              ...item,
              calculatedBalance: opening,
            };
          });

          setClosingBalance(
            sortedData[sortedData.length - 1].calculatedBalance
          );
        }

        // let array = Object.entries(response.data.data);
        // let array = Object.entries(sortedData);
        // let array1 = Object.entries(openingResponse.data.data);
        // let data: any = [];
        // let balance = 0;
        // if (array1.length > 0) {
        //   let temp = [] as any;
        //   // temp=array1[0][1];
        //   temp = array1[0];

        //   if (type == "Transaction" || type == "") {
        //     setOpeningBalance(
        //       temp.processed_opening_balance == "0"
        //         ? "0"
        //         : temp.processed_opening_balance
        //     );
        //     // setOpeningBalance(
        //     //   temp.Record.processed_opening_balance == "0"
        //     //     ? "0"
        //     //     : temp.Record.processed_opening_balance
        //     // );
        //     balance = parseFloat(
        //       temp.processed_opening_balance == "0"
        //         ? "0"
        //         : temp.processed_opening_balance
        //     );
        //     // balance = parseFloat(
        //     //   temp.Record.processed_opening_balance == "0"
        //     //     ? "0"
        //     //     : temp.Record.processed_opening_balance
        //     // );
        //   } else {
        //     setOpeningBalance("0");
        //     balance = parseFloat("0");
        //     setOpeningBalance(
        //       temp.realized_opening_balance == "0"
        //         ? "0"
        //         : temp.realized_opening_balance
        //     );
        //     // setOpeningBalance(
        //     //   temp.Record.realized_opening_balance == "0"
        //     //     ? "0"
        //     //     : temp.Record.realized_opening_balance
        //     // );
        //     balance = parseFloat(
        //       temp.realized_opening_balance == "0"
        //         ? "0"
        //         : temp.realized_opening_balance
        //     );
        //     // balance = parseFloat(
        //     //   temp.Record.realized_opening_balance == "0"
        //     //     ? "0"
        //     //     : temp.Record.realized_opening_balance
        //     // );
        //   }
        // }
        // setResAmc(amc_name);
        setResFund(fund);
        // setResType(type);
        setResFundAccount(fundAccount);
        setResAccountTitle(accountTitle);
        setResFromDate(fromDate);
        setResToDate(toDate);
        // array.forEach(([key, value]) => {
        //   data = value;
        //   let record = [];
        //   record["Record"] = data;
        //   record["Record"] = data;
        //   record["Record"]["ledger_id"] = data.Key;
        //   balance +=
        //     parseFloat(data.debit_amount) - parseFloat(data.credit_amount);
        //   record["Record"]["balance"] = balance.toFixed(2);
        //   // record["Record"] = data.Record;
        //   // record["Record"] = data.Record;
        //   // record["Record"]["ledger_id"] = data.Key;
        //   // balance +=
        //   //   parseFloat(data.Record.debit_amount) -
        //   //   parseFloat(data.Record.credit_amount);
        //   // record["Record"]["balance"] = balance.toFixed(2);
        //   bankStatement.push(record);
        // });
        // setClosingBalance(balance.toFixed(2));
        SetBankStatementDataCount(sortedData.length);
        setBankStatement(sortedData);
        setLoading(false);
        setIsSearchTrue(true);
        setFontSizeVal(18);
        // }else{
        //   toast.error('You cannot generate report upto 6 months')
        //   setLoading(false);
        // }
      } else {
        toast.warning("No activity for selected period!");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Error fetching data!");
      setLoading(false);
    }
  };

  const selectedFundName = React.useMemo(() => {
    const selectedFund = allFunds.find(
      (item) => `${item.fund_name} - ${item.symbol_code}` == fund
    );
    return selectedFund
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} - ${selectedFund.symbol_code}`,
        }
      : null;
  }, [allFunds, fund]);

  const selectedFundAmount = React.useMemo(() => {
    const selectedFund = allFundAccounts?.find(
      (item) => item?.account_title === accountTitle
    );
    return selectedFund
      ? {
          value: selectedFund.code,
          label: selectedFund.account_title,
        }
      : null;
  }, [allFundAccounts, accountTitle]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
        ? "hsla(291, 64%, 42%, 1)"
        : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
        ? "#2b3553"
        : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  useEffect(() => {
    if (bankStatement?.length > 0) {
      let sortedData = bankStatement
        ?.slice(0, itemsToShow)
        ?.sort((a, b) => a?.created_at_time - b?.created_at_time);
      let opening = sortedData[0]?.previous_balance || 0;
      sortedData = bankStatement?.slice(0, itemsToShow).map((item) => {
        opening =
          opening +
          parseFloat(item?.debit_amount || "0") -
          parseFloat(item?.credit_amount || "0");
        return {
          ...item,
          calculatedBalance: opening,
        };
      });
      setClosingBalance(sortedData[sortedData?.length - 1]?.calculatedBalance);
    }
  }, [itemsToShow, bankStatement]);

  useEffect(() => {
    const elements = document.querySelectorAll(
      "#test"
    ) as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal, itemsToShow, selectedValues, isSearchTrue]);

  useEffect(() => {
    const handleScreenResize = () => {
      setScreen(window?.outerWidth);
    };

    window.addEventListener("resize", handleScreenResize);
    handleScreenResize();

    return () => {
      window.removeEventListener("resize", handleScreenResize);
    };
  }, []);

  const fixedOrder = [
    "Create Date",
    "Settlement Date",
    "Transaction ID",
    "Description",
    "Debit Amount",
    "Credit Amount",
    "Balance",
  ];

  const handleDownloadSampleFile = () => {
    const TotalBalance = selectedValues?.columns?.map((ele, index) => {
      if (selectedValues?.columns?.length - 1 == index) {
        return `Opening Balance: ${numberWithCommas(
          openingBalance?.toFixed(4)
        )}`;
      } else {
        return "";
      }
    });

    const headings = [
      [selectedValues?.heading ? selectedValues?.heading : "", "", "", ""],
      [
        selectedValues?.sub_heading ? selectedValues?.sub_heading : "",
        "",
        "",
        "",
      ],
      ["fund", `${resFund}`, "Account Title", `${resAccountTitle}`],
      [
        "Account No",
        `${resFundAccount}`,
        "Settlement From Date",
        `${moment(resFromDate).format("DD-MM-YYYY")}`,
      ],
      [
        "Settlement To Date",
        `${moment(resToDate).format("DD-MM-YYYY")}`,
        "Report Date",
        `${moment(date).format("DD-MM-YYYY")}`,
      ],
      selectedValues?.balance?.includes("Opening Balance") &&
        (selectedValues?.columns?.length > 1
          ? [...TotalBalance]
          : ["Opening Balance: 0"]),
    ];

    const dataSequence = bankStatement?.slice(0, itemsToShow)?.map((item) => {
      return {
        Create_Date: validDate(moment(item.created_at).format("DD-MMM-YYYY")),
        Settlement_Date: validDate(
          moment(item?.txn_data?.settlement_date).format("DD-MMM-YYYY")
        ),
        Transaction_ID: item.txn_id.replace("TXN_", ""),
        Description: `${item.description?.slice(0, 400)}${
          item.description.length > 400 ? "..." : ""
        }`,
        Debit_Amount: numberWithCommas(item?.debit_amount?.toFixed(4)),
        Credit_Amount: numberWithCommas(item?.credit_amount?.toFixed(4)),
        Balance: numberWithCommas(item?.calculatedBalance?.toFixed(4) || 0),
      };
    });

    // dataSequence.push({
    //   Create_Date: "",
    //   Settlement_Date: "",
    //   Transaction_ID: "",
    //   Description: "",
    //   Debit_Amount: "",
    //   Credit_Amount: "",
    //   Balance: selectedValues?.balance?.includes("Closing Balance") ? `Closing Balance: ${numberWithCommas(closingBalance?.toFixed(4))}` : 0.0000,
    // })

    const reorderColumns = (columns, order) => {
      return order.filter((column) => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const result = {};
        reorderedColumns.forEach((column) => {
          if (column === "Create Date") {
            result[column] = entry?.Create_Date;
          } else if (column === "Settlement Date") {
            result[column] = entry?.Settlement_Date;
          } else if (column === "Transaction ID") {
            result[column] = entry?.Transaction_ID;
          } else if (column === "Description") {
            result[column] = entry?.Description;
          } else if (column === "Debit Amount") {
            result[column] = entry?.Debit_Amount;
          } else if (column === "Credit Amount") {
            result[column] = entry?.Credit_Amount;
          } else if (column === "Balance") {
            result[column] = entry?.Balance;
          }
        });
        return result;
      });

    if (ArrayData.length > 0) {
      const keys = Object.keys(ArrayData[0]);
      const lastKey = keys[keys.length - 1];

      const newObj1 = keys.reduce((acc, key) => {
        acc[key] =
          key === lastKey
            ? selectedValues?.balance?.includes("Closing Balance")
              ? `Closing Balance: ${numberWithCommas(
                  closingBalance?.toFixed(4)
                )}`
              : ""
            : "";
        return acc;
      }, {});
      ArrayData.push(newObj1);
    }

    generateExcel(
      "Bank Ledger Report",
      "Bank Ledger Report",
      "File",
      "File",
      "DCCL",
      headings,
      reorderedColumns,
      ArrayData,
      [],
      []
    );
    setLoadingExcel(false);
  };

  const handleTXT = () => {
    const TotalBalance = selectedValues?.columns?.map((ele, index) => {
      if (selectedValues?.columns?.length - 1 == index) {
        return `Opening Balance: ${numberWithCommas(
          openingBalance?.toFixed(4)
        )}`;
      } else {
        return "";
      }
    });

    const dataSequence = bankStatement?.slice(0, itemsToShow)?.map((item) => {
      return {
        Create_Date: validDate(moment(item.created_at).format("DD-MMM-YYYY")),
        Settlement_Date: validDate(
          moment(item?.txn_data?.settlement_date).format("DD-MMM-YYYY")
        ),
        Transaction_ID: item.txn_id.replace("TXN_", ""),
        Description: `${item.description?.slice(0, 400)}${
          item.description.length > 400 ? "..." : ""
        }`,
        Debit_Amount: numberWithCommas(item?.debit_amount?.toFixed(4)),
        Credit_Amount: numberWithCommas(item?.credit_amount?.toFixed(4)),
        Balance: numberWithCommas(item?.calculatedBalance?.toFixed(4) || 0),
      };
    });

    // dataSequence.push({
    //   Create_Date: "",
    //   Settlement_Date: "",
    //   Transaction_ID: "",
    //   Description: "",
    //   Debit_Amount: "",
    //   Credit_Amount: "",
    //   Balance: selectedValues?.balance?.includes("Closing Balance") ? `Closing Balance: ${numberWithCommas(closingBalance?.toFixed(4))}` : 0.0000,
    // })

    const reorderColumns = (columns, order) => {
      return order.filter((column) => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const result = {};
        reorderedColumns.forEach((column) => {
          if (column === "Create Date") {
            result[column] = entry?.Create_Date;
          } else if (column === "Settlement Date") {
            result[column] = entry?.Settlement_Date;
          } else if (column === "Transaction ID") {
            result[column] = entry?.Transaction_ID;
          } else if (column === "Description") {
            result[column] = entry?.Description;
          } else if (column === "Debit Amount") {
            result[column] = entry?.Debit_Amount;
          } else if (column === "Credit Amount") {
            result[column] = entry?.Credit_Amount;
          } else if (column === "Balance") {
            result[column] = entry?.Balance;
          }
        });
        return result;
      });

    if (ArrayData.length > 0) {
      const keys = Object.keys(ArrayData[0]);
      const lastKey = keys[keys.length - 1];

      const newObj1 = keys.reduce((acc, key) => {
        acc[key] =
          key === lastKey
            ? selectedValues?.balance?.includes("Closing Balance")
              ? `Closing Balance: ${numberWithCommas(
                  closingBalance?.toFixed(4)
                )}`
              : ""
            : "";
        return acc;
      }, {});
      ArrayData.push(newObj1);
    }

    let formattedContent = `${
      selectedValues?.heading ? selectedValues?.heading : ""
    },,,\n`;
    formattedContent += `${
      selectedValues?.sub_heading ? selectedValues?.sub_heading : ""
    },,,\n`;
    formattedContent += `"fund:","${resFund}",`;
    formattedContent += `"Account Title:","${resAccountTitle}",,\n`;
    formattedContent += `"Account No:","${resFundAccount}",`;
    formattedContent += `"Settlement From Date:","${moment(resFromDate).format(
      "DD-MM-YYYY"
    )}",,\n`;
    formattedContent += `"Settlement To Date:","${moment(resToDate).format(
      "DD-MM-YYYY"
    )}",`;
    formattedContent += `"Report Date:","${moment(date).format(
      "DD-MM-YYYY"
    )}",,\n`;

    formattedContent += TotalBalance?.map((col) => `"${col}"`).join(",") + "\n";

    exportToTxt(
      formattedContent,
      selectedValues,
      ArrayData,
      "Bank Ledger Report"
    );
    setLoadingText(false);
  };

  const handleShowMore = () => {
    setItemsToShow((prev) => prev + itemsPerPage);
  };

  const handleGeneratePdf = () => {
    const element = contentRef.current;
    let fileName = "Bank-Ledger.pdf";
    const options = {
      filename: fileName,
      margin: [10, 3, 10, 3],
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 1 },
      jsPDF: {
        unit: "mm",
        format: paperSizeVal || "A4",
        orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };
    html2pdf().from(element).set(options).save();
    setLoadingPDF(false);
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Bank Ledger Report</h4>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col md="2">
                        <div className="form-group">
                          <label>Select Fund</label>
                          <Select
                            value={selectedFundName}
                            label={"Select Fund"}
                            onChange={(e) => {
                              setFund(e?.label);
                              setFundCode(e?.value);
                              SetBankStatementDataCount(0);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                              setAccountTitle("");
                              setFundAccount("");
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundsDropDown()}
                            styles={customStyles}
                          />
                          {/* <select
                            className="form-control"
                            onChange={(e) => {
                              setFund(
                                e.nativeEvent.target == null
                                  ? ""
                                  : e.nativeEvent.target[e.target.selectedIndex]
                                    .text
                              );
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Fund
                            </option>
                            {renderFundsDropDown()}
                          </select> */}
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="form-group">
                          <label>Select Fund Account</label>
                          <Select
                            value={selectedFundAmount}
                            label={"Select Fund Account"}
                            onChange={(e) => {
                              var AccountTitle = e?.label;
                              setAccountTitle(AccountTitle);
                              const accountNo = allFundAccounts?.filter(
                                (item: any) => {
                                  return item?.code == e?.value;
                                }
                              );
                              setFundAccount(accountNo[0]?.account_no);
                              setAccountGlCode(accountNo[0]?.code);
                              SetBankStatementDataCount(0);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundAccountsDropDown()}
                            styles={customStyles}
                          />
                          {/* <select
                            className="form-control"
                            onChange={(e) => {
                              var AccountTitle =
                                e.nativeEvent.target == null
                                  ? ""
                                  : e.nativeEvent.target[e.target.selectedIndex]
                                    .text;
                              setAccountTitle(AccountTitle);
                              const accountNo = allFundAccounts.filter(
                                (item: any) => {
                                  return item.code == e.target.value;
                                }
                              );
                              console.log("ACCOUNT => ", accountNo);
                              setFundAccount(accountNo[0].account_no);
                              setAccountGlCode(accountNo[0].code);
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Fund Account
                            </option>
                            {renderFundAccountsDropDown()}
                          </select> */}
                        </div>
                      </Col>

                      {/* <Col md="2">
                <div className="form-group">
                  <label>Select Type</label>
                  <select
                    className="form-control"
                    onChange={(e) => {
                        setType(e.target.value);
                    }}>
                      <option value="" defaultChecked hidden>
                      Select Type
                    </option>
                    <option value="Transaction">Transaction</option>
                    <option value="Realized">Realized</option>
                  </select>
                </div>
              </Col> */}

                      <Col md="2">
                        <div className="form-group  ">
                          <label>Date From</label>
                          <input
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            type="date"
                            defaultValue={fromDate}
                            className="form-control py-1"
                            onChange={(e) => {
                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setFromDate(date);
                              SetBankStatementDataCount(0);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                          />
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="form-group  ">
                          <label>Date To</label>
                          <input
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            type="date"
                            defaultValue={toDate}
                            className="form-control py-1"
                            onChange={(e) => {
                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setToDate(date);
                              SetBankStatementDataCount(0);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="2">
                        <div
                          style={{
                            marginTop: "5px",
                          }}
                        >
                          {/* here Search Button */}
                          <button
                            style={{
                              paddingTop: "8px",
                              paddingBottom: "8px",
                            }}
                            className="btn btn-primary mt-4"
                            onClick={() => {
                              searchData();
                            }}
                            disabled={Boolean(loading) || !fund || !fundAccount}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Loading...</span>
                              </>
                            ) : (
                              <span>Search</span>
                            )}
                          </button>
                        </div>
                      </Col>
                    </Row>
                    {/* End */}
                  </div>
                </div>

                {/* here Search results for report Data */}
                <div className="card mt-3">
                  <div className="card-body">
                    {/* ------------------ Report template starts here ---------- */}
                    {bankStatement.length > 0 && bankStatementDataCount > 0 && (
                      <Row>
                        <ReportTemplates
                          ColumnArr={ColumnArr}
                          selectedValues={selectedValues}
                          setSelectedValues={setSelectedValues}
                          pdfExportComponent={pdfExportComponent}
                          setFontSizeVal={setFontSizeVal}
                          fontSizeVal={fontSizeVal}
                          setPaperSizeVal={setPaperSizeVal}
                          paperSizeVal={paperSizeVal}
                          setLayoutVal={setLayoutVal}
                          layoutVal={layoutVal}
                          setScalePDF={setScalePDF}
                          scalePDF={scalePDF}
                          setMarginPDF={setMarginPDF}
                          marginPDF={marginPDF}
                          setScreenSizePerPdf={setScreenSizePerPdf}
                          screenSizePerPdf={screenSizePerPdf}
                          setDimensionOfPages={setDimensionOfPages}
                          contentRef={contentRef}
                          fileName={"Bank-Statement-" + date + ".pdf"}
                          printExcel={handleDownloadSampleFile}
                          printTXT={handleTXT}
                          printpdf={handleGeneratePdf}
                        />
                      </Row>
                    )}
                    {/* ------------------ Report template ends here ---------- */}
                    <div
                      id="printDiv"
                      className="p-4"
                      style={{
                        // background: "white",
                        color: "black",
                        minWidth: "200px",
                        overflowX: "auto",
                        width: "auto",
                      }}
                    >
                      <div
                        style={{
                          width: `${
                            dimensionOfPages?.find(
                              (item) => item?.key == paperSizeVal
                            )?.dimensions[layoutVal == "Portrait" ? 0 : 1]
                          }`,
                          height: "auto",
                          margin: "0 auto",
                          backgroundColor: "white",
                        }}
                        className="border"
                      >
                        <PDFExport
                          paperSize="A4"
                          margin="1.5cm"
                          scale={0.6}
                          repeatHeaders={true}
                          fileName={"Bank-Statement-" + date + ".pdf"}
                          ref={pdfExportComponent}
                        >
                          <div
                            style={{
                              margin: "0.25in",
                            }}
                            ref={contentRef}
                          >
                            {!loading && bankStatementDataCount > 0 ? (
                              <>
                                <ReportHeader title="Bank Statement" />
                                <Row>
                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Fund:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {resFund}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Account Title:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {resAccountTitle}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Account No:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {resFundAccount}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Settlement From Date:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {moment(resFromDate).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Settlement To Date:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {moment(resToDate).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Report Date:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {moment(date).format("DD-MM-YYYY")}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                {selectedValues?.columns?.length > 0 ? (
                                  <div>
                                    <>
                                      <div
                                        style={{
                                          overflowX: "auto",
                                          overflowY: "hidden",
                                        }}
                                      >
                                        {selectedValues?.balance?.includes(
                                          "Opening Balance"
                                        ) && (
                                          <div
                                            id="test"
                                            className="float-right"
                                          >
                                            <b id="test">Opening Balance</b> :{" "}
                                            {openingBalance
                                              ? Math.sign(
                                                  parseFloat(openingBalance)
                                                ) === 1
                                                ? `${numberWithCommas(
                                                    parseFloat(
                                                      openingBalance
                                                        ?.toString()
                                                        ?.replace("-", "") || 0
                                                    )?.toFixed(2)
                                                  )} Dr.`
                                                : Math.sign(
                                                    parseFloat(openingBalance)
                                                  ) === -1
                                                ? `${numberWithCommas(
                                                    parseFloat(
                                                      openingBalance
                                                        ?.toString()
                                                        ?.replace("-", "") || 0
                                                    )?.toFixed(2)
                                                  )} Cr.`
                                                : "0"
                                              : "0"}
                                            {/* {openingBalance
                                                ? numberWithCommas(
                                                  parseFloat(
                                                    openingBalance || "0"
                                                  )?.toFixed(4)
                                                )
                                                : 0} */}
                                          </div>
                                        )}
                                        <table
                                          className="report"
                                          style={{ color: "black" }}
                                        >
                                          <thead
                                            style={{ alignSelf: "center" }}
                                          >
                                            <tr>
                                              {selectedValues?.columns?.includes(
                                                "Create Date"
                                              ) && (
                                                <th
                                                  className="htmltoPdfStyle"
                                                  id="test"
                                                >
                                                  Create Date
                                                </th>
                                              )}
                                              {selectedValues?.columns?.includes(
                                                "Settlement Date"
                                              ) && (
                                                <th
                                                  className="htmltoPdfStyle"
                                                  id="test"
                                                >
                                                  Settlement Date
                                                </th>
                                              )}
                                              {selectedValues?.columns?.includes(
                                                "Transaction ID"
                                              ) && (
                                                <th
                                                  className="htmltoPdfStyle"
                                                  id="test"
                                                >
                                                  Transaction ID
                                                </th>
                                              )}
                                              {selectedValues?.columns?.includes(
                                                "Description"
                                              ) && (
                                                <th
                                                  className="htmltoPdfStyle"
                                                  id="test"
                                                >
                                                  Description
                                                </th>
                                              )}
                                              {selectedValues?.columns?.includes(
                                                "Debit Amount"
                                              ) && (
                                                <th
                                                  className="text-right"
                                                  id="test"
                                                >
                                                  Debit Amount
                                                </th>
                                              )}
                                              {selectedValues?.columns?.includes(
                                                "Credit Amount"
                                              ) && (
                                                <th
                                                  className="text-right"
                                                  id="test"
                                                >
                                                  Credit Amount
                                                </th>
                                              )}
                                              {selectedValues?.columns?.includes(
                                                "Balance"
                                              ) && (
                                                <th
                                                  className="text-right"
                                                  id="test"
                                                >
                                                  Balance
                                                </th>
                                              )}
                                            </tr>
                                          </thead>
                                          <tbody className="report-table-body">
                                            {/* {type == "Transaction" || type == ""
                                    ?  */}
                                            {!loading &&
                                            bankStatement &&
                                            bankStatement.length > 0
                                              ? bankStatement
                                                  ?.slice(0, itemsToShow)
                                                  .map(
                                                    (
                                                      item: any,
                                                      index: number
                                                    ) => {
                                                      return (
                                                        <>
                                                          <tr key={index}>
                                                            {selectedValues?.columns?.includes(
                                                              "Create Date"
                                                            ) && (
                                                              <td
                                                                className="htmltoPdfStyle"
                                                                id="test"
                                                              >
                                                                {validDate(
                                                                  moment(
                                                                    item.created_at
                                                                  ).format(
                                                                    "DD-MMM-YYYY"
                                                                  )
                                                                )}
                                                              </td>
                                                            )}
                                                            {selectedValues?.columns?.includes(
                                                              "Settlement Date"
                                                            ) && (
                                                              <td
                                                                className="htmltoPdfStyle"
                                                                id="test"
                                                              >
                                                                {validDate(
                                                                  moment(
                                                                    item
                                                                      ?.txn_data
                                                                      ?.settlement_date
                                                                  ).format(
                                                                    "DD-MMM-YYYY"
                                                                  )
                                                                )}
                                                              </td>
                                                            )}
                                                            {selectedValues?.columns?.includes(
                                                              "Transaction ID"
                                                            ) && (
                                                              <td
                                                                className="htmltoPdfStyle"
                                                                id="test"
                                                              >
                                                                {item.txn_id.replace(
                                                                  "TXN_",
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {selectedValues?.columns?.includes(
                                                              "Description"
                                                            ) && (
                                                              <td
                                                                className="htmltoPdfStyle"
                                                                id="test"
                                                              >
                                                                {item.description?.slice(
                                                                  0,
                                                                  400
                                                                )}{" "}
                                                                {item
                                                                  .description
                                                                  .length >
                                                                  400 && "..."}
                                                              </td>
                                                            )}
                                                            {selectedValues?.columns?.includes(
                                                              "Debit Amount"
                                                            ) && (
                                                              <td
                                                                id="test"
                                                                className="text-right htmltoPdfStyle"
                                                              >
                                                                {numberWithCommas(
                                                                  item?.debit_amount?.toFixed(
                                                                    4
                                                                  )
                                                                )}
                                                              </td>
                                                            )}
                                                            {selectedValues?.columns?.includes(
                                                              "Credit Amount"
                                                            ) && (
                                                              <td
                                                                id="test"
                                                                className="text-right htmltoPdfStyle"
                                                              >
                                                                {numberWithCommas(
                                                                  item?.credit_amount?.toFixed(
                                                                    4
                                                                  )
                                                                )}
                                                              </td>
                                                            )}
                                                            {/* <td className="text-right">
                                                  {numberWithCommas(
                                                    item.balance || 0
                                                  )}
                                                </td> */}
                                                            {selectedValues?.columns?.includes(
                                                              "Balance"
                                                            ) && (
                                                              <td
                                                                id="test"
                                                                className="text-right htmltoPdfStyle"
                                                              >
                                                                {item?.calculatedBalance
                                                                  ? Math.sign(
                                                                      parseFloat(
                                                                        item?.calculatedBalance
                                                                      )
                                                                    ) === 1
                                                                    ? `${numberWithCommas(
                                                                        parseFloat(
                                                                          item?.calculatedBalance
                                                                            ?.toString()
                                                                            ?.replace(
                                                                              "-",
                                                                              ""
                                                                            ) ||
                                                                            0
                                                                        )?.toFixed(
                                                                          2
                                                                        )
                                                                      )} Dr.`
                                                                    : Math.sign(
                                                                        parseFloat(
                                                                          item?.calculatedBalance
                                                                        )
                                                                      ) === -1
                                                                    ? `${numberWithCommas(
                                                                        parseFloat(
                                                                          item?.calculatedBalance
                                                                            ?.toString()
                                                                            ?.replace(
                                                                              "-",
                                                                              ""
                                                                            ) ||
                                                                            0
                                                                        )?.toFixed(
                                                                          2
                                                                        )
                                                                      )} Cr.`
                                                                    : "0"
                                                                  : "0"}
                                                                {/* {numberWithCommas(
                                                                  item?.calculatedBalance?.toFixed(
                                                                    4
                                                                  ) || 0
                                                                )} */}
                                                              </td>
                                                            )}
                                                          </tr>
                                                        </>
                                                      );
                                                    }
                                                  )
                                              : null}
                                          </tbody>
                                        </table>
                                        {selectedValues?.balance?.includes(
                                          "Closing Balance"
                                        ) && (
                                          <div
                                            id="test"
                                            className="float-right"
                                          >
                                            <b id="test">Closing Balance</b> :{" "}
                                            {closingBalance
                                              ? Math.sign(
                                                  parseFloat(closingBalance)
                                                ) === 1
                                                ? `${numberWithCommas(
                                                    parseFloat(
                                                      closingBalance
                                                        ?.toString()
                                                        ?.replace("-", "") || 0
                                                    )?.toFixed(2)
                                                  )} Dr.`
                                                : Math.sign(
                                                    parseFloat(closingBalance)
                                                  ) === -1
                                                ? `${numberWithCommas(
                                                    parseFloat(
                                                      closingBalance
                                                        ?.toString()
                                                        ?.replace("-", "") || 0
                                                    )?.toFixed(2)
                                                  )} Cr.`
                                                : "0"
                                              : "0"}
                                            {/* {closingBalance
                                                ? numberWithCommas(
                                                  parseFloat(
                                                    closingBalance || "0"
                                                  )?.toFixed(4)
                                                )
                                                : 0} */}
                                          </div>
                                        )}
                                      </div>
                                    </>
                                  </div>
                                ) : (
                                  <div className="text-center my-5">
                                    <b>No column selected</b>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="table-empty">
                                <BsTable className="icon" />
                                <p className="text-center text-primary empty-text">
                                  No record found
                                </p>
                              </div>
                            )}
                          </div>
                        </PDFExport>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        {selectedValues?.columns?.length > 0 &&
                          bankStatementDataCount > 0 &&
                          bankStatement?.length >= 10 && (
                            <UncontrolledDropdown
                              className="me-2 mt-2"
                              direction="down"
                            >
                              <DropdownToggle
                                id="TotalRecord_dropdown"
                                style={{
                                  background: "none",
                                  padding: "0px",
                                  margin: "0px",
                                }}
                                className="border"
                                // style={{
                                //   borderRadius: "4px",
                                //   color: theme == "light" ? "black" : "",
                                // }}
                                // caret
                                // size="sm"
                              >
                                <div
                                  id="report_dropdown"
                                  style={{
                                    borderRadius: "4px",
                                    padding: "5px 15px",
                                    color: theme == "light" ? "black" : "white",
                                  }}
                                >
                                  Per page : {itemsPerPage}
                                </div>

                                {/* {selectedValues?.columns?.length > 0 &&
                                bankStatementDataCount > 0
                                ? bankStatement?.length
                                : 0} */}
                              </DropdownToggle>
                              <DropdownMenu
                                style={{
                                  // width: "100%",
                                  maxHeight: "300px",
                                  overflow: "auto",
                                  backgroundColor:
                                    theme == "dark" ? "rgb(30, 30, 47)" : "",
                                }}
                              >
                                <DropdownItem
                                  className={
                                    itemsPerPage == 10
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(10);
                                    setItemsToShow(10);
                                  }}
                                >
                                  10
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == 25
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(25);
                                    setItemsToShow(25);
                                  }}
                                >
                                  25
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == 50
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(50);
                                    setItemsToShow(50);
                                  }}
                                >
                                  50
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == "All"
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage("All");
                                    setItemsToShow(bankStatement?.length);
                                  }}
                                >
                                  All
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          )}
                      </div>
                      <div className="col-md-4">
                        {itemsToShow < bankStatement?.length &&
                          selectedValues?.columns?.length > 0 &&
                          bankStatementDataCount > 0 && (
                            <div className="d-flex justify-content-center my-2">
                              <button
                                className="btn btn-primary mt-3"
                                onClick={handleShowMore}
                              >
                                Show More
                              </button>
                            </div>
                          )}
                      </div>
                      <div className="col-md-4">
                        {selectedValues?.columns?.length > 0 &&
                          bankStatementDataCount > 0 &&
                          bankStatement?.length > 0 && (
                            <div className="d-flex align-items-center justify-content-end">
                              <div
                                id="TotalRecord_dropdown"
                                className="border dropdown-toggle btn btn-secondary btn-sm ml-1"
                                style={{
                                  borderRadius: "4px",
                                  color: theme == "light" ? "black" : "white",
                                  marginTop: "13px",
                                }}
                              >
                                Total record :{" "}
                                {selectedValues?.columns?.length > 0 &&
                                bankStatementDataCount > 0
                                  ? bankStatement?.length
                                  : 0}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BankStatement;
